import { createStore, Provider } from 'jotai';
import {
  infiniteRecentlyViewedGoodsAtom,
  type InfiniteRecentlyViewedGoods,
} from './infiniteRecentlyViewedGood.atom';
import { memo, useEffect } from 'react';

const store = createStore();

export const JotaiProvider = memo(
  ({
    children,
    infiniteRecentlyViewedGoods,
  }: {
    children: React.ReactNode;
    infiniteRecentlyViewedGoods: InfiniteRecentlyViewedGoods;
  }) => {
    useEffect(() => {
      store.set(infiniteRecentlyViewedGoodsAtom, infiniteRecentlyViewedGoods);
    }, [infiniteRecentlyViewedGoods]);
    return <Provider store={store}>{children}</Provider>;
  },
);
